module.exports = __webpack_public_path__ + "static/fav_icon-3bc63af36f782f052f8c1e6ab39c0397.ico";